import React from 'react';
import logo from './assets/images/youbie-logo.png';

const Navbar = () => {
 
    return (
        <div>
         {/* <!--Starts Header Area--> */}
        <header id="main-header" className="header-main sticky top-0 z-50">
          <nav className="navigation-menu ">
            <div className="container">
              <a href="#home" className="brand">
              <img
                src={logo}
                alt="Youbie"
                className="brand-logo" style={{width:"162px", height:"41px"}}
              />
              </a>
              <ul className="nav-menu__nav">
                <li className="nav-menu__nav-item">
                  <a href="#home" className="nav-item-link">Home</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#explore" className="nav-item-link">Explore</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#streamers" className="nav-item-link">Stream</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#top-teams" className="nav-item-link">Bets</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#nfts" className="nav-item-link">NFT Marketplace</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#top-teams" className="nav-item-link">Whitepaper</a>
                </li>
              </ul>
              <div className="user-group">
                <div className="cta-group">
                  <a href="#go-premium" className="you-btn"> Buy Premium </a>
                  <a href="#" className="you-btn"> Connect Wallet </a>
                </div>
                <div className="dropdown user-details-btn">
                <label tabIndex="0" >
                <button
                    className="btn dropdown-toggle"
                    type="button"
                    id="userCridentials"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-circle-user"></i>
                    <span className="icon">
                      <svg
                        version="1.2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 18 12"
                        width="18"
                        height="12"
                      >
                          
                        <path
                          style={{  fill: '#fff'}}
                          d="m0.9 0.3l8.1 6 8.1-6v5.1l-8.1 6-8.1-6z"
                        />
                      </svg>
                    </span>
                  </button>
                  </label>
                  <ul tabIndex="0"  className="menu menu-compact dropdown-content  ml-[-60px] mt-6" aria-labelledby="userCridentials">
                    <li><a className="dropdown-item" href="#">Dashboard</a></li>
                    <li><a className="dropdown-item" href="#">Settings</a></li>
                  </ul>
                </div>
              </div>
              <div className=" dropdown lg:hidden">
                <label tabIndex="0" >
                <button
                    className="btn dropdown-toggle"
                    type="button"
                    id="userCridentials"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="fa-solid fa-circle-user"></i>
                    <span className="icon">
                      <svg
                        version="1.2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 18 12"
                        width="18"
                        height="12"
                      >
                          
                        <path
                          style={{  fill: '#fff'}}
                          d="m0.9 0.3l8.1 6 8.1-6v5.1l-8.1 6-8.1-6z"
                        />
                      </svg>
                    </span>
                  </button>
                  </label>
                  <ul tabIndex="0"  className="menu menu-compact dropdown-content rounded-md shadow ml-[-65px] mt-2 bg-[#18b3e9]" aria-labelledby="userCridentials">
                    <li><a className="dropdown-item " href="#">Dashboard</a></li>
                    <li><a className="dropdown-item" href="#">Settings</a></li>
                  </ul>
                </div>

              <div className="dropdown lg:hidden">

                    <label tabIndex="0" >
           
                    <button type="button" className="menu-btn">
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
            
                    </label>
                    
                    
                    <ul tabIndex="0" className="menu menu-compact dropdown-content p-2 shadow  w-52  ml-[-150px] bg-[#100032]">
              
                      
                       <li className="nav-menu__nav-item">
                  <a href="#home" className="nav-item-link mt-4">Home</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#explore" className="nav-item-link">Explore</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#streamers" className="nav-item-link">Stream</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#top-teams" className="nav-item-link">Bets</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#nfts" className="nav-item-link">NFT</a>
                </li>
                <li className="nav-menu__nav-item">
                  <a href="#top-teams" className="nav-item-link">Whitepaper</a>
                </li>
                    </ul>
                </div>
            </div>
          </nav>
        </header>
        {/* <!--Ends Header Area--> */}
        </div>
    );
};

export default Navbar;




